import { create } from "zustand";

export const tiposConsumo = [
  { value: 0, label: 'SMS' },
  { value: 1, label: 'Correo' },
  { value: 2, label: 'Whatsapp' },
  { value: 3, label: 'Voz' }
];

const reporteConsumoStore = create((set) => ({
  /*FILTROS GENERAR REPORTE*/
  cargaActiva: false,
  editarCargaActiva: (data) => set({ cargaActiva: data }),
  fecha: new Date(),
  editarFecha: (data) => set({ fecha: data }),
  selTipoConsumo: tiposConsumo,
  editarSelTipoConsumo: (data) => set({ selTipoConsumo: data }),
  /*FILTROS GENERAR REPORTE*/

  /*FILTROS DE REPORTE*/
  selectedTipoConsumo: [],
  editarSelectedTipoConsumo: (data) => set({ selectedTipoConsumo: data }),
  mostrarFiltros: false,
  editarMostrarFiltros: (data) => set({ mostrarFiltros: data }),
  vehiculos: [],
  editarVehiculos: (data) => set({ vehiculos: data }),
  selVehiculos: [],
  editarSelVehiculos: (data) => set({ selVehiculos: data }),
  contactos: [],
  editarContactos: (data) => set({ contactos: data }),
  selContactos: [],
  editarSelContactos: (data) => set({ selContactos: data }),
  alertas: [],
  editarAlertas: (data) => set({ alertas: data }),
  selAlertas: [],
  editarSelAlertas: (data) => set({ selAlertas: data }),
  /*FILTROS DE REPORTE*/

  /*REPORTE*/
  usuarioOmisiones: null,
  editarUsuarioOmisiones: (data) => set({ usuarioOmisiones: data }),
  sms: null,
  editarSMS: (data) => set({ sms: data }),
  email: null,
  editarEmail: (data) => set({ email: data }),
  whatsapp: null,
  editarWhatsapp: (data) => set({ whatsapp: data }),
  voz: null,
  editarVoz: (data) => set({ voz: data }),
  /*REPORTE*/

  /*LISTADOS DEL REPORTE*/
  vehiculos: [],
  editarVehiculos: (data) => set({ vehiculos: data }),
  mensajesSms: [],
  editarMensajesSms: (data) => set({ mensajesSms: data }),
  mensajesWhatsapp: [],
  editarMensajesWhatsapp: (data) => set({ mensajesWhatsapp: data }),
  mensajesEmail: [],
  editarMensajesEmail: (data) => set({ mensajesEmail: data }),
  mensajesVoz: [],
  editarMensajesVoz: (data) => set({ mensajesVoz: data }),

  mensajesSelSms: [],
  editarMensajesSelSms: (data) => set({ mensajesSelSms: data }),
  mensajesSelWhatsapp: [],
  editarMensajesSelWhatsapp: (data) => set({ mensajesSelWhatsapp: data }),
  mensajesSelEmail: [],
  editarMensajesSelEmail: (data) => set({ mensajesSelEmail: data }),
  mensajesSelVoz: [],
  editarMensajesSelVoz: (data) => set({ mensajesSelVoz: data }),
  /*LISTADOS DEL REPORTE*/
}));

export default reporteConsumoStore;